<script>
    import { onMount } from 'svelte';
    import Modal, { getModal } from './modals/OnMountModal.svelte';
	// import { modal } from './stores.js';
    // import PopupForNewUserInternal from './PopupForNewUserInternal.svelte';
    export let showTips;

    const getContactCardSms = () => {

        fetch(`/api/v1/get-contact-card`)
        .then(data => {
            return data.json()
        })
        .then(response => console.log(response))
    }

    onMount(() => getModal().open(showTips))
</script>

<!-- the modal without an `id` -->
<Modal>
    <h1>how it works</h1>
    <ol style="margin-bottom: 40px;">
        <li>Save the evergreen contact card to your phone to quickly save links via SMS.</li>
        <button
            class="primary-red"
            style="cursor:pointer;"
            on:click={() => getContactCardSms()}
        >Send contact card to my phone</button>
        <li>Sending links via SMS is the way. It's fast and easy.</li>
        <li>Your groups are private.</li>
        <li>Invite friends to your groups to share links.</li>
        <!-- <li>On Sunday we'll send you a roundup of all the links your group shared.</li> -->
    </ol>
	<!-- opening a model with an `id` and specifying a callback	 -->
</Modal>

<style>
    h1 {
        padding-left: 24px;
    }
    ol {
        font-weight: 600;
    }
    li {
        margin-bottom: 8px;
    }
    button.primary-red {
        margin-bottom: 25px;
    }
</style>